import { customReservedInventoryBucketTypeIdFormat } from "@redotech/redo-model/ids";
import * as z from "zod/v4";

export const createCustomReservedInventoryBucketType = {
  name: "createCustomReservedInventoryBucketType" as const,
  input: z.object({ name: z.string().min(1) }),
  output: z.object({ id: customReservedInventoryBucketTypeIdFormat.schema }),
};
